import { Component, OnInit, Input, ElementRef, ViewChild, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { VIDEOCONFERENCE_CONSTANTS } from '../../../../constants/videoconference.constants';
import { WidgetProperties } from '@opentok/client';
import { ParticipantsService } from '../../../../services/participants/participants.service';
import { Room } from '../../../../models';
import { EVENTS_CONSTANTS } from '../../../../constants/events.constants';
import { SessionStorageService } from '../../../../services/session-storage/session-storage.service';
import { StateHandlerService } from '../../../../services/state-handler/state-handler.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'sas-screen-share',
  standalone: true,
  imports: [NgClass],
  templateUrl: './screen-share.component.html',
  styleUrls: ['./screen-share.component.scss']
})
export class ScreenShareComponent implements OnInit {
  public showScreen: boolean = false;
  @Input() session?: OT.Session;
  @Input() stream?: OT.Stream;
  @Input() streams: Array<any> = [];
  @ViewChild('screenDiv', { static: true }) private screenDiv?: ElementRef;
  private videoConstants = VIDEOCONFERENCE_CONSTANTS;
  private events = EVENTS_CONSTANTS;

  constructor(
    private readonly participantsSvc: ParticipantsService,
    private readonly sessionStorageSrv: SessionStorageService,
    private readonly stateHandlerSvc: StateHandlerService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ){}

  ngOnInit() {
    if (this.session) {
      this.session.on(this.events.SESSION_EVENTS.STREAM_DESTROYED, (event: any) => {
        if (event.reason === this.videoConstants.SCREEN_SHARING.REASONS.CLIENT_DISCONNECTED) {
          if (this.sessionStorageSrv.get('stopSharingScreen')) {
            console.log('User clicked stop sharing');
            (document.querySelector('.screen-share-position') as any)['style'].display = 'none'; // To avoid subscriber buttons locked
            this.showScreen = false;

          } else {
            for (let i = 0; i < this.streams.length; i++) {
              if (this.streams[i].defaultFitMode === 'contain') {
                this.streams.splice(i, 1);
                this.stateHandlerSvc.get('roomData').subscribe((response: Room) => {
                  this.participantsSvc.setParticipants([...this.streams], response, true);
                });
                this.changeDetectorRef.detectChanges();
                i = this.streams.length;
              }
            }
          }

          this.sessionStorageSrv.set('stopSharingScreen', true);
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['stream'] && changes['stream'].currentValue !== undefined && this.screenDiv) {
      const subOptions: WidgetProperties = {
        width: '100%',
        height: '100%',
        fitMode: 'contain',
        insertMode: 'append',
      };
      this.showScreen = true;
      this.sessionStorageSrv.set('stopSharingScreen', false);
      this.session?.subscribe(changes['stream'].currentValue, this.screenDiv.nativeElement, subOptions);
      (document.querySelector('.screen-share-position') as any)['style'].display = 'block';
    }
  }

}
